const ITEMS = [
  "Béton architectural",
  "Pierre naturelle",
  "Bois de charpente",
  "Isolation biosourcée",
  "Carrelage & faïence",
  "Enduits de façade",
  "Couverture & zinguerie",
  "Menuiseries",
  "Aménagement extérieur",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display italic text-xl sm:text-2xl text-petrol/70 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2.5 h-5 rounded-t-full bg-teal/50 shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-petrol/10 bg-creme py-6 select-none"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
